import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "@/components/Reveal";
import { ChapterLabel } from "@/components/ChapterLabel";

const faqs = [
  {
    q: "¿Necesito un diagnóstico?",
    a: "No. Puedes entrar si tienes una evaluación de altas capacidades, estás explorándolo o simplemente te identificas profundamente con las experiencias descritas.",
  },
  {
    q: "¿La comunidad es terapia?",
    a: "No. Es un espacio de conversación y apoyo entre personas con experiencias similares. No sustituye la atención de profesionales de la salud.",
  },
  {
    q: "¿Dónde está la comunidad?",
    a: "La conversación principal se desarrolla en una comunidad privada de WhatsApp.",
  },
  {
    q: "¿Los demás miembros verán mi número?",
    a: "Dependiendo de la configuración y las funciones de WhatsApp, otros miembros podrían ver tu nombre, fotografía o número. Antes de entrar, revisa la información de privacidad y configura tu perfil como prefieras.",
  },
  {
    q: "¿Tengo que escribir todos los días?",
    a: "No. Puedes participar a tu ritmo. También puedes observar y leer hasta que te sientas preparado para intervenir.",
  },
  {
    q: "¿Qué ocurre después de pagar?",
    a: "Completarás tus datos y recibirás las instrucciones para solicitar acceso a la comunidad privada.",
  },
  {
    q: "¿Puedo cancelar?",
    a: "Sí. Puedes cancelar la renovación de la suscripción desde el área de miembro. Mantendrás el acceso hasta que termine el periodo que ya hayas pagado.",
  },
  {
    q: "¿Qué pasa si alguien incumple las normas?",
    a: "La administración podrá advertir, silenciar o expulsar a quien ponga en riesgo la seguridad y la convivencia de la comunidad.",
  },
];

export const Preguntas = () => (
  <section id="preguntas-frecuentes" className="bg-[#0E1628] px-5 py-24 md:py-32">
    <div className="mx-auto max-w-[800px]">
      <Reveal>
        <ChapterLabel number="09" testId="chapter-preguntas" />
        <h2 className="text-3xl font-semibold tracking-tight text-[#F5F1EA] md:text-5xl">
          Preguntas frecuentes
        </h2>
      </Reveal>

      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="mt-12" data-testid="faq-accordion">
          {faqs.map((faq, i) => (
            <AccordionItem
              key={faq.q}
              value={`faq-${i}`}
              className="border-b border-[#22304D]"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i + 1}`}
                className="py-6 text-left font-[Fraunces] text-base font-semibold text-[#F5F1EA] hover:text-[#8B7CF6] hover:no-underline md:text-lg"
              >
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-sm leading-relaxed text-[#9AA6BE] md:text-base">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
